import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const OFFICE_INFO = {
  ROOT: `${PRIVATE_ROOT}/community/office-info`,
  ADDRESS: `${PRIVATE_ROOT}/community/office-info/address`,
  OFFICE_HOURS: `${PRIVATE_ROOT}/community/office-info/hours`,
}
